





import { Component, Vue } from "vue-property-decorator";

@Component
export default class McmCancelButton extends Vue {}
